import {MovementType, OuraHeartIntf, OuraSleepIntf, OuraTagIntf, OuraWorkoutIntf, SleepPhaseType} from '@djsharkk/logr-types';
import {DateTime, Duration, DurationUnit}                                                         from 'luxon';


export const ProcessSleepData = (data: OuraSleepIntf[]): OuraSleepIntf[] => {
	return data.map(row => ({
		...row,
		day              : new Date(row.day as unknown as string),
		bedtime_end      : new Date(row.bedtime_end as unknown as string),
		bedtime_start    : new Date(row.bedtime_start as unknown as string),
		heart_rate       : {
			...row.heart_rate,
			timestamp: new Date(row.heart_rate.timestamp as unknown as string)
		},
		hrv              : {
			...row.hrv,
			timestamp: new Date(row.hrv.timestamp as unknown as string)
		},
		movement_30_sec  : (row.movement_30_sec as unknown as string)
			.split('')
			.map((m, i) => ({
				value    : parseFloat(m) as MovementType,
				timestamp: mapOuraIntervals(row.bedtime_start as unknown as string, 'seconds', 30 * i)
			})),
		sleep_phase_5_min: (row.sleep_phase_5_min as unknown as string)
			.split('')
			.map((phase, i) => ({
				value    : parseFloat(phase) as SleepPhaseType,
				timestamp: mapOuraIntervals(row.bedtime_start as unknown as string, 'minutes', 5 * i)
			}))
	}))
}

export const ProcessHeartData = (data: OuraHeartIntf[]): OuraHeartIntf[] => {
	return data.map(row => {
		return {
			...row,
			timestamp: new Date(row.timestamp as unknown as string)
		}
	})
}

export const ProcessWorksData = (data: OuraWorkoutIntf[]): OuraWorkoutIntf[] => {

	return data.map(row => {
		return {
			...row,
			end_datetime  : new Date(row.end_datetime as unknown as string),
			start_datetime: new Date(row.start_datetime as unknown as string),
			day           : new Date(row.day as unknown as string)
		}
	})
}

export const ProcessTagsData = (data: OuraTagIntf[]): OuraTagIntf[] => {
	return data.map(row => {
		return {
			...row,
			start_time: new Date(row.start_time as unknown as string),
			end_time  : new Date(row.end_time as unknown as string),
			start_day : new Date(row.start_day as unknown as string),
			end_day   : new Date(row.end_day as unknown as string)
		}
	});
}

export const mapOuraIntervals = (d: string, u: DurationUnit, v: number) => {
	return DateTime.fromISO(d)
				   .plus(Duration.fromObject({[u]: v}))
				   .toJSDate()
}